// Sidebar entries owned by the Livechat module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { livechatPaths } from './paths'

// The sidebar fields Livechat's entry uses. Structurally the app's SidebarType
// (src/types/shared): src/app/nav.tsx places these entries, so a drift between
// the two fails typecheck there.
interface LivechatNavItem {
    title: string
    path: string
}

export const livechatNav = {
    list: {
        title: 'livechat',
        path: livechatPaths.livechat,
    },
} satisfies Record<string, LivechatNavItem>
